import { Component, inject } from '@angular/core';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../constantes/cybermetrie.enum';
import { GlobalStoreService } from '@services/global-store/global-store.service';
import { ContexteModificationEnum } from '../../constantes/contexte-modification.enum';

@Component({
  selector: 'app-bouton-nous-joindre',
  templateUrl: './bouton-nous-joindre.component.html',
  standalone: false,
})
export class BoutonNousJoindreComponent {
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);
  private readonly globalStoreService = inject(GlobalStoreService);

  onClickNousJoindre() {
    this.cybermetrieCoordonneesService.actionClick(this.getCybermetrieLabel());
  }

  private getCybermetrieLabel(): string {
    const contexte = this.globalStoreService.getContexteModification() as ContexteModificationEnum;
    switch (contexte) {
      case ContexteModificationEnum.ADRESSE:
        return CybermetrieEnum.LABEL_MODIFIER_ADRESSE_NOUS_JOINDRE;
      case ContexteModificationEnum.COURRIEL:
        return CybermetrieEnum.LABEL_MODIFIER_COURRIEL_NOUS_JOINDRE;
      case ContexteModificationEnum.TELEPHONE:
        return CybermetrieEnum.LABEL_MODIFIER_TELEPHONE_NOUS_JOINDRE;
      default:
        return CybermetrieEnum.LABEL_MODIFIER_COORDONNEES_NOUS_JOINDRE;
    }
  }
}
